import moment from 'moment';
import React from 'react';

export const text = (str) => {
  return str ? str.toString() : 'sin datos';
};

export const date = (str) => {
  if (!str) return 'No registra';
  return moment(str).format('YYYY-MM-DD');
};

export const datetime = (str) => {
  if (!str) return 'No registra';
  return moment(str).format('YYYY-MM-DD HH:mm:ss');
};
export const time = (str) => {
  if (!str) return 'No registra';
  return moment(str).format('HH:mm:ss');
};

export const number = (nStr) => {
  if (nStr == null) {
    return 'No registra';
  }
  nStr += '';
  const x = nStr.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? `.${x[1]}` : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
};

export const money = (val) => {
  if (val == null) {
    return 'no registra';
  }
  const numVal = Number(val);
  if (!Number.isNaN(numVal)) {
    return `$${number(numVal.toFixed(2))}`;
  }
  return val;
};

export const boolean = (value) => {
  return value ? 'SI' : 'NO';
};

export const transactionType = (value) => {
  return value === 'topUp' ? 'Recarga' : 'paquete';
};
export const status = (value) => {
  const upper = value?.toUpperCase();
  if (upper === 'SUCCESS') return <span className="px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">Exitosa</span>;
  if (upper === 'ERROR') return <span className="px-2 py-1 rounded text-xs font-medium bg-red-100 text-red-800">Error</span>;
  return <span className="px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800">Procesando</span>;
};

export const image = (value) => {
  return <img src={value} width={80}/>;
};

export default {
  text,
  date,
  datetime,
  number,
  money,
  cash: money,
  boolean,
  time,
  image,
  status,
  transactionType
};
